<template>
  <tr>
    <td class="align-middle is-v-select-wrapper">
      {{ groupName }}
    </td>
    <td class="align-middle">
      <img
        v-if="groupImageUrl"
        :src="groupImageUrl"
        alt=""
        class="group-image" />
      <span
        v-else
        class="group-empty-image">
        <i class="material-icons">camera_alt</i>
      </span>
    </td>
    <td class="align-middle text-center">
      <span
        v-if="groupMinimumPrice"
        class="text-primary pb-2 d-block">
        {{ groupMinimumPrice }} / {{ $t('ui.piecesAbbr') }}
      </span>

      <d-button
        v-if="!isOrderView"
        @click.prevent="showPricesPopup">
        {{ $t('price.seePricelist') }}
      </d-button>
    </td>
    <td class="align-middle">
      <d-textarea
        v-if="!readOnly"
        v-model="servicesGroupData.customer_description"
        :value.prop="servicesGroupData.customer_description"
        :placeholder="$t('service.yourCommentsOnServiceOptional')"
        :rows="10" />

      <pre v-if="readOnly">
        <template v-if="servicesGroupData.customer_description">
          {{ servicesGroupData.customer_description }}
        </template><template v-else>{{ $t('inquiries.noComments') }}&hellip;</template>
      </pre>
    </td>
    <td
      v-if="!readOnly"
      class="align-middle">
      <d-button
        outline
        @click.prevent="removeServicesGroup()"
        theme="danger">
        {{ $t('ui.delete') }}
      </d-button>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'request-creator-services-group',
  props: [
    'currencyId',
    'readOnly',
    'servicesGroupData',
    'servicesGroupIndex',
    'servicesGroups',
    'services',
    'selectedCurrencySymbol',
    'isOrderView'
  ],
  computed: {
    groupName () {
      let id = this.servicesGroupData.service_group_id;
      let foundedServicesGroup = this.servicesGroups.filter(serviceGroup => serviceGroup.id === id, 10);

      if (foundedServicesGroup.length) {
        return foundedServicesGroup[0].name;
      }

      return '';
    },
    groupImageUrl () {
      let id = this.servicesGroupData.service_group_id;
      let foundedServicesGroup = this.servicesGroups.filter(serviceGroup => serviceGroup.id === id, 10);

      if (foundedServicesGroup.length) {
        return foundedServicesGroup[0].image_url;
      }

      return false;
    },
    groupMinimumPrice () {
      let servicesInGroup = this.services.filter(service => service.group_id === this.servicesGroupData.service_group_id);
      let lowestPrice = false;

      if (!servicesInGroup.length) {
        return false;
      }

      for (let i = 0; i < servicesInGroup.length; i++) {
        let prices = servicesInGroup[i].prices.filter(price => price.currency_id === this.currencyId);

        if (prices.length) {
          for (let j = 0; j < prices.length; j++) {
            if (lowestPrice === false) {
              lowestPrice = prices[j].price;
            } else if (prices[j].price < lowestPrice) {
              lowestPrice = prices[j].price;
            }
          }
        }
      }

      if (lowestPrice !== false) {
        return Number(lowestPrice).toFixed(2) + ' ' + this.selectedCurrencySymbol;
      }

      return false;
    }
  },
  methods: {
    removeServicesGroup () {
      this.$bus.$emit('request-creator-remove-services-group', this.servicesGroupIndex);
    },
    showPricesPopup () {
      this.$bus.$emit('request-creator-service-prices-popup-open', this.servicesGroupData.service_group_id);
    }
  }
}
</script>

<style lang="scss" scoped>
.group {
  &-image {
    height: auto;
    max-height: 160px;
    max-width: 160px;
    width: auto;
  }

  &-empty-image {
    align-items: center;
    background: #e5e5e5;
    color: #fff;
    display: flex;
    font-size: 96px;
    height: 160px;
    justify-content: center;
    width: 160px;

    .material-icons {
      font-size: 72px;
    }
  }
}

pre {
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  padding: 20px;
  white-space: pre-line;
}
</style>
